import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './home.generated.css';
import { HeroSection } from './HeroSection';
import { RiskSection } from './RiskSection';
import { OperationalSection } from './OperationalSection';
import { SolutionSection } from './SolutionSection';
import { HowItWorksSection } from './HowItWorksSection';
import { WhoSection } from './WhoSection';
import { CtaSection } from './CtaSection';
import { Footer } from './Footer';

export default function Home(): JSX.Element {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      // Defer to next tick to ensure sections are mounted
      window.setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 50);
    }
  }, [location.hash]);

  return (
    <div className='strada-public-home min-h-screen bg-background'>
      <main>
        <HeroSection />
        <RiskSection />
        <OperationalSection />
        <SolutionSection />
        <HowItWorksSection />
        <WhoSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
